import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { formatDate } from "../lib/utils";
import { ShieldCheck } from "lucide-react";

const ACTION_ES = { create:"Creó", update:"Actualizó", delete:"Eliminó", deactivate:"Desactivó" };
const ENTITY_ES = { user:"usuario", area:"área", task:"tarea", project:"proyecto" };

export default function AuditPage() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/audit").then(({data}) => setItems(data)); }, []);
  return (
    <div className="space-y-6">
      <div>
        <div className="text-[11px] uppercase tracking-widest text-slate-500 font-semibold">Bitácora</div>
        <h1 className="font-heading text-2xl sm:text-3xl font-bold text-slate-900 tracking-tight">Registro de auditoría</h1>
        <p className="text-sm text-slate-500 mt-1">Últimas 500 acciones ejecutadas en el sistema.</p>
      </div>
      <div className="bg-white border border-slate-200 rounded-lg divide-y divide-slate-100">
        {items.map(a => (
          <div key={a.id} className="p-4 flex items-start gap-3">
            <div className="w-9 h-9 rounded-md bg-slate-100 text-slate-600 flex items-center justify-center"><ShieldCheck className="w-4 h-4" /></div>
            <div className="flex-1">
              <div className="text-sm text-slate-800">
                <span className="font-semibold">{a.user_name}</span> <span className="text-slate-500">·</span> {ACTION_ES[a.action] || a.action} un(a) {ENTITY_ES[a.entity] || a.entity}
              </div>
              {a.details && Object.keys(a.details).length > 0 && (
                <div className="text-xs text-slate-500 mt-0.5">{Object.entries(a.details).map(([k,v]) => `${k}: ${typeof v === "object" ? JSON.stringify(v) : v}`).join(" · ")}</div>
              )}
              <div className="text-xs text-slate-400 mt-1">{formatDate(a.timestamp)}</div>
            </div>
          </div>
        ))}
        {items.length === 0 && <div className="p-12 text-center text-sm text-slate-400">Sin registros aún.</div>}
      </div>
    </div>
  );
}
